<template>
  <div>
    <v-icon small class="mr-2" @click="editParameter()"> mdi-pencil </v-icon>
    <b-modal
      v-if="showModal"
      ref="modalParameter"
      :title="`Parametro: ${parameter.id}`"
      size="xl"
      hide-footer
      no-enforce-focus
    >
      <form class="form">
        <div class="pb-5">
          <v-row>
            <v-col cols="12">
              <div class="alert alert-custom alert-warning" role="alert">
                <div class="alert-icon">
                  <i class="flaticon-warning"></i>
                </div>
                <div class="alert-text">
                  Cualquier cambio en esta área puede afectar negativamente el
                  desempeño del sistema.
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="parameter.descripcion"
                label="Descripción"
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="parameter.valor" label="Valor" dense>
              </v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex justify-content-between pt-10 float-right">
            <v-btn
              @click="saveParameter()"
              color="primary"
              dark
              class="font-weight-bold text-uppercase px-9 py-4"
            >
              Guardar
            </v-btn>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import KTUtil from "@/assets/js/components/util";
import Swal from "sweetalert2";
import { SAVE_PARAMETER_DATA } from "@/core/services/store/setting.module";
export default {
  name: "ParameterEdit",
  props: {
    parameter: Object,
    getParameters: Function,
  },
  data() {
    return {
      showModal: true,
    };
  },
  methods: {
    async editParameter() {
      const oVue = this;
      oVue.$refs["modalParameter"].show();
    },
    async saveParameter() {
      const oVue = this;
      const textAlert = "Si, acepto.";

      const { value: textConfirmation } = await Swal.fire({
        title: "Alerta",
        input: "text",
        html: `Debe escribir <b>${textAlert}</b> en el cuadro más abajo para actualizar`,
        icon: "warning",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) return "Debe escribir el texto";
          if (value !== textAlert)
            return "Debe escribir el texto correctamente";
        },
      });
      if (textConfirmation !== textAlert) return;

      const parameter = oVue.parameter;
      oVue.setLoading();
      const oData = parameter;

      oVue.saveParameterData(oData).then((asaveParameterResponse) => {
        oVue.removeLoading();
        if (asaveParameterResponse.result) {
          Swal.fire({
            title: "¡Enhorabuena!",
            text: `Los datos de el parametro fueron guardados exitosamente`,
            icon: "success",
          });
          oVue.getParameters();
        } else {
          Swal.fire({
            title: `Error al guardar el parametro`,
            text: asaveParameterResponse.message,
            icon: "error",
          });
        }
      });
    },
    async saveParameterData(aData) {
      let oVue = this;
      const asaveParameterResponse = await oVue.$store.dispatch(
        SAVE_PARAMETER_DATA,
        aData
      );
      return asaveParameterResponse;
    },
    setLoading() {
      this.showModal = false;
      KTUtil.setLoading();
    },
    removeLoading() {
      this.showModal = true;
      KTUtil.removeLoading();
    },
  },
};
</script>
